<template>
    <SizeForm :size="size" v-if="loaded" :readOnly="false" />
</template>

<script>
import {BModal, BButton, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import SizeForm from './SizeForm.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    SizeForm
  },
  data() {
    return {
      size:null,
      loaded:false,
    }
  },
  methods:{
    
  },
  async mounted()
  {
    this.size=await APIRequest.detail('sizes',this.$route.params.id)
    this.loaded=true
  }
}
</script>
